import PropTypes from 'prop-types';
import addressShape from 'react/signups/card/shapes/AddressShape';

const cardAccountTrustShape = PropTypes.shape({
  accountId: PropTypes.number,
  address: addressShape,
  beneIsCardholder: PropTypes.bool,
  beneficiaryOwnershipType: PropTypes.string,
  documentationVerified: PropTypes.bool,
  id: PropTypes.string,
  idvLinkForBeneficiaryOwner: PropTypes.string,
  idvLinkForControlPerson: PropTypes.string,
  slug: PropTypes.string,
  trustName: PropTypes.string,
  trusteeCategory: PropTypes.string,
  trusteeName: PropTypes.string,
  trusteeTitle: PropTypes.string,
  trusteeTitleMatches: PropTypes.bool,
});

export default cardAccountTrustShape;
